import {connect} from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

import {stopImpersonation} from '../../redux/reducers/auth';

const ImpersonationBanner = props => {
  const navigate = useNavigate();
  if (!props?.impersonationUser) return null;
  return (
    <Alert severity='warning'>
      You are impersonating {props?.user?.email}. {' '}
      <Button
        color='warning'
        size='small'
        variant='outlined'
        onClick={() => {
          props.stopImpersonation();
          navigate('/providers');
        }}
      >
        Stop impersonating
      </Button>
      <Button
        color='warning'
        size='small'
        variant='outlined'
        onClick={() => {
          navigate('/clients');
        }}
      >
        View Patient Dashboard
      </Button>
      <Button
        color='warning'
        size='small'
        variant='outlined'
        onClick={() => {
          navigate('/providers');
        }}
      >
        View Provider Dashboard
      </Button>
    </Alert>
  );
};

const mapState = state => ({
  impersonationUser: state?.auth?.impersonationUser,
});
const mapDispatch = dispatch => ({
  stopImpersonation: () => dispatch(stopImpersonation()),
});

export default connect(mapState,mapDispatch)(ImpersonationBanner);